/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $) {
	'use strict';

	/**
	 * Background Container
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class BackgroundContainer
	 * @extends Tc.Module
	 */
	Module.BackgroundContainer = Module.extend({

		CHANNEL_INTERACTIVE_MODE: 'BCInteractiveMode',
		isEditMode: false,

		/**
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			this.isEditMode = window.CQ && window.CQ.WCM && window.CQ.WCM.isEditMode(true);
			this.interactiveMode = this.$ctx.hasClass('interactivemode');
			this.noDeactivate = this.$ctx.hasClass('no-deactivate');
			this.mobileGallery = this.$ctx.closest('.modMobileGallery');
			this.tabNavigationContent = this.$ctx.closest('.modTabNavigationContent');
			this.slideChangeHandlerFunction = this.handleCarouselSlideChanged.bind(this);

			if(this.interactiveMode) {
				this.sandbox.subscribe(this.CHANNEL_INTERACTIVE_MODE, this);
				this.interactiveElementName = this.$ctx.data('interactive-name');
				this.interactiveElementValue = this.$ctx.data('interactive-value');
			}

			this.tailBackgroundColor();

			callback();
		},

		after: function() {
			if(this.interactiveMode) {
				this.addEvents();
			}
		},

		/**
		 * Add Event Listeners
		 * @param skipNextSlideChangedEvent
		 */
		addEvents: function(skipNextSlideChangedEvent){
			this.$ctx.on('click', $.proxy(this.handleBackgroundClicked, this));
			// scCarouselSlideChanged triggers after an animation time passed. Sometimes you need to skip one event
			// but listen to the following events. (i.e. when onUpdateInteractiveState is called)
			if(skipNextSlideChangedEvent){
				this.mobileGallery.one('scCarouselSlideChanged', this.handleSkipNextEvent.bind(this));
			}
			else {
				this.handleSkipNextEvent();
			}
		},

		removeEvents: function() {
			this.$ctx.off('click');
			this.mobileGallery.off('scCarouselSlideChanged', this.slideChangeHandlerFunction);
		},

		handleSkipNextEvent: function() {
			this.mobileGallery.on('scCarouselSlideChanged', this.slideChangeHandlerFunction);
		},

		handleCarouselSlideChanged: function(event, carouselListItem) {
			if($.contains(carouselListItem[0], this.$ctx[0])) {
				this.interactiveStateActivate();
				this.broadcastInteractiveState();
			}
			else {
				this.interactiveStateDeactivate();
			}
		},

		handleBackgroundClicked: function(event){
			var currentTime = new Date().getTime();
			var $eventTarget = $(event.currentTarget);

			if (!$eventTarget.is(this.$ctx)) {
				return;
			}
			// prevent double-clicks
			if(this.lastClickTime && (currentTime - this.lastClickTime) < 100) {
				return;
			}

			this.lastClickTime = currentTime;

			if (this.isActive) {
				this.interactiveStateDeactivate(true);
			} else {
				this.interactiveStateActivate();
				this.broadcastInteractiveState();
			}
		},

		interactiveStateActivate: function () {
			if (this.isActive) {
				return;
			}

			this.isActive = true;
			this.$ctx.addClass('active');
		},

		updateTabNavigation: function() {
			this.tabNavigationContent.triggerHandler('activate');
		},

		updateMobileCarousel: function(){
			this.mobileGallery.trigger('scCarouselSlideToElement', [this.$ctx]);
		},

		broadcastInteractiveState: function() {
			this.fire('interactiveStateChanged', {
				name: this.interactiveElementName,
				value: this.interactiveElementValue
			}, [this.CHANNEL_INTERACTIVE_MODE]);
		},

		interactiveStateDeactivate: function (userInteraction) {
			if(userInteraction && this.noDeactivate) {
				return;
			}

			this.isActive = false;
			this.$ctx.removeClass('active');
		},

		onUpdateInteractiveState: function (data) {
			if(data.name !== this.interactiveElementName) {
				return;
			}

			if(data.value === this.interactiveElementValue) {
				this.removeEvents();
				this.interactiveStateActivate();
				this.updateTabNavigation();
				this.updateMobileCarousel();
				this.addEvents(true);
			} else {
				this.interactiveStateDeactivate();
			}
		},

		tailBackgroundColor: function() {
			var $backgroundColor = this.$ctx.css('backgroundColor');
			var $tail = this.$ctx.find('.tail');

			$tail.css('borderColor', $backgroundColor);
		}
	});
}(window.Tc.Module, window.Tc.$));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.BackgroundContainer.js
// module id = 37
// module chunks = 0